module.exports = new __parcel__URL__("amnesiac.8d5e8e9e.jpg").toString();